import React from 'react';
import { useIntl } from 'react-intl-next';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { breakoutMessages as messages } from '../messages';
var fullWidthLabelWrapperStyles = xcss({
  height: "var(--ds-space-400, 32px)",
  display: 'flex',
  backgroundColor: 'elevation.surface.overlay',
  borderRadius: 'border.radius',
  boxShadow: 'elevation.shadow.overlay',
  boxSizing: 'border-box',
  alignItems: 'center'
});
var fullWidthLabelStyles = xcss({
  marginLeft: 'space.100',
  marginRight: 'space.100',
  paddingLeft: 'space.075',
  paddingRight: 'space.075',
  paddingTop: 'space.050',
  paddingBottom: 'space.050'
});
export var ResizerBreakoutModeLabel = function ResizerBreakoutModeLabel(_ref) {
  var breaktoutLayout = _ref.layout;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var message = React.useMemo(function () {
    switch (breaktoutLayout) {
      case 'full-width':
        return formatMessage(messages.fullWidthLabel);
      case 'wide':
        return formatMessage(messages.wideWidthLabel);
      default:
        return null;
    }
  }, [breaktoutLayout, formatMessage]);
  return message && /*#__PURE__*/React.createElement(Box, {
    xcss: fullWidthLabelWrapperStyles
  }, /*#__PURE__*/React.createElement(Inline, {
    xcss: fullWidthLabelStyles
  }, message));
};